// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605140840/js/" + chunkId + "." + {"44":"de765412","225":"c4e06881","481":"6d3f39a9","486":"f9ec805f","770":"cf61d82f"}[chunkId] + ".0.09594494619509097.chunk.js";
};